import React, { useEffect } from 'react';

export default function Refund() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-[2rem] p-8 md:p-12 shadow-sm border border-slate-100">
          <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-8">Refund Policy</h1>
          
          <div className="space-y-6 text-slate-600 leading-relaxed">
            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Prescription Medications</h2>
            <p>
              By law, prescription medications cannot be returned or refunded once they have been dispensed and shipped by the pharmacy. This policy ensures the safety and integrity of all medications provided to our patients.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Consultation Fees</h2>
            <p>
              If a licensed healthcare provider determines that you are not eligible for treatment during your initial consultation, you will not be charged for the medication, and any consultation fees (if applicable) may be refunded.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Damaged or Incorrect Orders</h2>
            <p>
              If your medication arrives damaged, compromised, or if you receive the wrong item, please contact our support team immediately. We will investigate the issue and coordinate with the pharmacy to arrange a replacement at no additional cost to you.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Cancellations</h2>
            <p>
              You may cancel your order at any time before the pharmacy dispenses and ships the medication. Once an order is marked as "shipped" or "dispensed," it cannot be canceled or refunded.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Subscription Services</h2>
            <p>
              For ongoing treatment plans, you may cancel your subscription at any time. Cancellations must be made at least 48 hours before your next scheduled processing date to avoid being charged for the upcoming shipment.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}